import Stack from '@mui/material/Stack'

import { DataGridToolbarColumnsButton } from './DataGridToolbarColumnsButton'
import { DataGridToolbarExportButton } from './DataGridToolbarExportButton'
import { DataGridToolbarHistoryButton } from './DataGridToolbarHistoryButton'
import { DataGridToolbarResetFilteringButton } from './DataGridToolbarResetFilteringButton'
import { DataGridToolbarResetSortingButton } from './DataGridToolbarResetSortingButton'

interface DataGridToolbarDefaultButtonsProps {
  /**
   * Optional configuration for the search history button.
   * If provided, the history button will be included in the toolbar.
   */
  historyButton?: {
    scope: string
    getUserID: () => string
    columnNameTranslator?: (columnKey: string) => string
  }
}

export function DataGridToolbarDefaultButtons({ historyButton }: DataGridToolbarDefaultButtonsProps = {}) {
  return (
    <Stack direction='row' spacing={1} sx={{ marginLeft: 'auto' }}>
      {historyButton && (
        <DataGridToolbarHistoryButton
          scope={historyButton.scope}
          getUserID={historyButton.getUserID}
          columnNameTranslator={historyButton.columnNameTranslator}
        />
      )}
      <DataGridToolbarExportButton />
      <DataGridToolbarResetSortingButton />
      <DataGridToolbarResetFilteringButton />
      <DataGridToolbarColumnsButton />
    </Stack>
  )
}
